/**
 * Orion Analytics
 * Financial Intelligence Platform
 *
 * Copyright (c) 2026 Santosh Bag / Orion Analytics Ltd.
 * All rights reserved.
 *
 * Software Development by Cosmo Codeworks Ltd
 *
 * Unauthorized copying, modification, distribution,
 * or commercial use is prohibited.
 */

import "../../css/software.css"

export default function OrionMobilePage() {
  return (
    <div className="product-detail-page">
      <section className="product-hero">
        <div>
          <span className="badge coming">
            COMING SOON
          </span>

          <h1>Orion Mobile</h1>

          <h3>
            The Full Orion Analytics Experience
            on Mobile
          </h3>

          <p>
            Orion Mobile will bring market dashboards,
            stock screening, analytics, watchlists,
            news and portfolio insights directly to
            your mobile device.
          </p>
        </div>
      </section>

      <section className="features-grid">
        <div className="feature-card">
          Market Dashboard
        </div>

        <div className="feature-card">
          Stock Screening
        </div>

        <div className="feature-card">
          News & Sentiment
        </div>

        <div className="feature-card">
          Portfolio Tracking
        </div>
      </section>
    </div>
  );
}